var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabbed-page-layout',{staticClass:"warehouse",attrs:{"title":"Lager","pages":_vm.pages}})
}
var staticRenderFns = []

export { render, staticRenderFns }